import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';
import { PathStyleExtension } from '@deck.gl/extensions';

export const HISTORICALHCCL_LAYER_ID = 'historicalHCCLLayer';

export const CATEGORY_COLORS = {
  'City Line': [241, 100, 119],
};

const layerConfig = {
  title: 'VRU HCCL segment',
};

function HistoricalHCCLLayer() {
  const dispatch = useDispatch();
  const { historicalHCCLLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, historicalHCCLLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (historicalHCCLLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: HISTORICALHCCL_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: historicalHCCLLayer.visible,
      opacity: historicalHCCLLayer.opacity,

      getLineColor: [213, 0, 249],
      lineWidthMinPixels: 10,

/*       getDashArray: [3, 1.5],
      dashJustified: true,
      dashGapPickable: true,
      extensions: [new PathStyleExtension({ dash: true })], */

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: HISTORICALHCCL_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },
      onclick: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['hccl_name'],
            }),
          };
        }
      },
      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['hccl_name'],
            }),
          };
        }
      },
    });
  }
}

export default HistoricalHCCLLayer;
